import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import Integration from "../pages/medium/integration";
import VerifyEmail from "../pages/admin/calendar/verifyemail";
import Onboarding from "../pages/medium/onboarding";
import OnboardingBooking from "../pages/onboardingbooking";
import OnboardingBookingGuard from "../pages/onboardingbooking/onboardingBookingGuard";

const MediumOnBoardingRoute = () => {
  return (
    <Routes>
      <Route path="/" element={<Navigate to="/onboarding-process" />} />
      <Route path="/onboarding-process" element={<Onboarding />} />
      <Route path="/verifyemail" element={<VerifyEmail />} />
      <Route path="/onboarding-booking/:mediumId" element={<OnboardingBooking />} />
      <Route path="/booking" element={<OnboardingBookingGuard />} />
      <Route path="*" element={<Navigate to="/" />} />
    </Routes>
  );
};
export default MediumOnBoardingRoute;
